module.exports = __webpack_public_path__ + "hu.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/hu.svg
// module id = 856
// module chunks = 0